import { render, staticRenderFns } from "./HistoryResultsList.vue?vue&type=template&id=0cc0329a&scoped=true&"
import script from "./HistoryResultsList.vue?vue&type=script&lang=ts&"
export * from "./HistoryResultsList.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryResultsList.vue?vue&type=style&index=0&id=0cc0329a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc0329a",
  null
  
)

export default component.exports